<template>
  <div>
    <v-dialog :value="editModel.active" width="600" persistent >
            <v-card v-if="editedItem">
              <v-card-title>
                <span class="text-h5">Update Document</span>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pa-3">
                <v-container>
                  <v-form v-model="editModel.valid">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-virtual-keyboard
                          :rules="[formRules.required]"
                          v-model="editedItem.fileName"
                          label="File Name"
                          required
                          readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          clearable
                          v-virtual-keyboard
                          :rules="[formRules.required]"
                          v-model="editedItem.documentNumber"
                          label="Document No."
                          required></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          clearable
                          v-virtual-keyboard
                          :rules="[formRules.required]"
                          v-model="editedItem.documentTitle"
                          label="Document Title"
                          required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          clearable
                          v-virtual-keyboard
                          :rules="[formRules.required]"
                          v-model="editedItem.revisionNumber"
                          label="Revision"
                          required></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-select
                          outlined
                          dense
                          hide-details
                          v-model="editedItem.documentTypeId"
                          :items="documentTypes"
                          :menu-props="{ offsetY: true }"
                          item-text="name"
                          item-value="id"
                          smallChips
                          label="Document Type"
                          required></v-select>
                      </v-col>
                    </v-row>

                    <v-row>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="editModel.loading" @click="closeEditDialog"> Cancel </v-btn>
                <v-btn
                  color="primary"
                  class="elevation-0"
                  width="150px"
                  :disabled="!editModel.valid "
                  :loading="editModel.loading"
                  @click="saveEditItem">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  </div>
</template>

<script>
 import formRules from '@/features/Share/config/form-rules';
import { mapGetters } from 'vuex';
export default {
data(){
    return {
      formRules,
      editedItem:null,
        editModel: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
    }
},
computed:{
  ...mapGetters('DOCUMENT_TYPE', {
        loading: 'GET_LOADING',
        documentTypes: 'GET_ENTRIES'
       
      }),
      forgeTags: function () {
        return this.$store.getters.GET_ALL_EXISTING_TAGS;
      },
},
methods:{
  open(item){
    
    this.editedItem=item;
    this.editModel.active=true;
  },
  saveEditItem(){
    this.editModel.loading = true;
    this.$emit("updateCompleted",this.editedItem);
    this.resetEditModel();
    this.closeEditDialog();
  },
  resetEditModel(){
    this.editModel.loading = false;
        this.editModel.valid = true;
        this.editModel.hasChanges = false;
  },
  closeEditDialog() {
    this.editedIndex = -1;
    this.editedItem = null;
    this.editModel.active = false;
  }
},
components:{

}
}
</script>

<style>

</style>